import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, PageMetaModule, provideConfig } from '@spartacus/core';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { CustomBreadcrumbComponent } from './custom-breadcrumb.component';

@NgModule({
  imports: [I18nModule, CommonModule, RouterModule, PageMetaModule, CustomIconsModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        BreadcrumbComponent: {
          component: CustomBreadcrumbComponent,
        },
      },
    }),
  ],
  declarations: [CustomBreadcrumbComponent],
  exports: [CustomBreadcrumbComponent],
})
export class CustomBreadcrumbModule {}
